import React, { useState, useEffect, useRef } from "react";
import { Col, Container, Modal, Row } from "react-bootstrap";
import { FaEye } from "react-icons/fa";
import Pagination from "../components/Pagination";
import pdfIcon from "../../assets/images/blog/pdf.png";
import axios from "axios";
import Loader from "../components/Loader";

const PreviousPapers = () => {
  const [baseurl, setBaseurl] = useState("");
  const [previousList, setPreviousList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [selectedPdf, setSelectedPdf] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalItems, setTotalItems] = useState(0);
  const [bgImage, setBgImage] = useState("");
  const itemsPerPage = 8;

  useEffect(() => {
    fetchPreviousPapers();
    bannerimg();
  }, []);

  const fetchPreviousPapers = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/previous-list`
      );
      setPreviousList(res.data.data || []);
      setBaseurl(res.data.imagePath || "");
      setTotalItems(res.data.total || res.data.data.length); // Set total items count
      setError(null);
    } catch (error) {
      console.error("Error fetching previous papers:", error);
      setError("Failed to load previous papers. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const bannerimg = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/home-seeting-list`
      );

      const baseUrl = res.data.imagePath;
      const courseImage = res.data.home_setting[0]?.course_image;

      // Full image URL
      const fullUrl = baseUrl + courseImage;

      setBgImage(fullUrl);
    } catch (error) {
      console.error("Error fetching banner:", error);
    }
  };

  // Pagination Logic
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentPapers = previousList.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  // View PDF handler
  const handleView = (pdf) => {
    setSelectedPdf(`${baseurl}${pdf}`);
    setShowModal(true);
  };

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
    // Scroll to top when page changes
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "50vh" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "50vh" }}
      >
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      </div>
    );
  }

  return (
    <section className="course paper">
      <div className="page_header"></div>
      <div className="rs-breadcrumbs breadcrumbs-overlay">
        <div className="breadcrumbs-img">
          <img src={bgImage} alt="Breadcrumbs bg" />
        </div>
        <div className="breadcrumbs-text white-color">
          <h1 className="page-title">Previous Papers</h1>
        </div>
      </div>
      <Container>
        <Row className="py-60">
          {currentPapers.length > 0 ? (
            currentPapers.map((paper, index) => (
              <Col xl={3} lg={4} md={6} key={paper.id || index}>
                <div className="course_card blog_card mb-24">
                  <div className="blog_card_img_block">
                    <img src={pdfIcon} alt={paper.title} />
                    <p className="date">
                      {paper.created_at
                        ? new Date(paper.created_at).toLocaleDateString("en-GB")
                        : ""}
                    </p>
                  </div>
                  <div className="blog_card_text_block">
                    <a
                      className="blog_title"
                      href={`${baseurl}${paper.pdf}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {paper.title}
                    </a>
                    <button
                      className="educate_link_btn"
                      onClick={() => handleView(paper.pdf)}
                    >
                      <FaEye /> View
                    </button>
                    {/* <a
                        href={`${baseurl}${paper.pdf}`}
                        className="educate_link_btn"
                        target="_blank"
                        download
                        rel="noopener noreferrer"
                      >
                        <FaDownload /> Download
                      </a> */}
                  </div>
                </div>
              </Col>
            ))
          ) : (
            <Col className="text-center">
              <p>No previous papers available.</p>
            </Col>
          )}

          {totalItems > itemsPerPage && (
            <Pagination
              currentPage={currentPage}
              setCurrentPage={handlePageChange}
              totalPages={totalPages}
            />
          )}
        </Row>
      </Container>

      <Modal backdrop="static"
        size="lg"
        className="page_pdf"
        show={showModal}
        // 
      >
        <Modal.Header closeButton onHide={() => setShowModal(false)}>
          <Modal.Title>PDF Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "80vh", overflow: "hidden", padding: 0 }}>
          {selectedPdf && <PdfViewer pdfUrl={selectedPdf} />}
        </Modal.Body>
      </Modal>
    </section>
  );
};

// PDF Viewer Component
const PdfViewer = ({ pdfUrl }) => {
  const [pdfDocument, setPdfDocument] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [scale, setScale] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const canvasRef = useRef(null);

  useEffect(() => {
    // Check if PDF.js is already loaded
    if (window.pdfjsLib) {
      loadPdf();
      return;
    }

    // Load PDF.js library dynamically
    const script = document.createElement("script");
    script.src =
      "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.4.120/pdf.min.js";
    script.onload = () => {
      window.pdfjsLib.GlobalWorkerOptions.workerSrc =
        "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.4.120/pdf.worker.min.js";
      loadPdf();
    };
    script.onerror = () => {
      setError("Failed to load PDF viewer. Please try again later.");
      setLoading(false);
    };
    document.head.appendChild(script);

    return () => {
      if (script.parentNode) {
        document.head.removeChild(script);
      }
    };
  }, [pdfUrl]);

  useEffect(() => {
    if (pdfDocument) {
      renderPage();
    }
  }, [pdfDocument, currentPage, scale]);

  const loadPdf = () => {
    setLoading(true);
    setError(null);

    // Load the PDF
    const loadingTask = window.pdfjsLib.getDocument(pdfUrl);
    loadingTask.promise
      .then(function (pdf) {
        setPdfDocument(pdf);
        setPageCount(pdf.numPages);
        setCurrentPage(1);
        setLoading(false);
      })
      .catch(function (error) {
        console.error("Error loading PDF:", error);
        setError("Failed to load PDF document. Please try again later.");
        setLoading(false);
      });
  };

  const renderPage = () => {
    if (!pdfDocument || !canvasRef.current) return;

    pdfDocument.getPage(currentPage).then(function (page) {
      const viewport = page.getViewport({ scale: scale });
      const canvas = canvasRef.current;
      const context = canvas.getContext("2d");

      canvas.height = viewport.height;
      canvas.width = viewport.width;

      const renderContext = {
        canvasContext: context,
        viewport: viewport,
      };

      page.render(renderContext);
    });
  };

  const goToPrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const goToNextPage = () => {
    if (currentPage < pageCount) {
      setCurrentPage(currentPage + 1);
    }
  };

  const zoomIn = () => {
    setScale((prevScale) => prevScale + 0.25);
  };

  const zoomOut = () => {
    if (scale > 0.5) {
      setScale((prevScale) => prevScale - 0.25);
    }
  };

  const showNotification = () => {
    const notification = document.getElementById("pdf-notification");
    if (notification) {
      notification.classList.add("show");
      setTimeout(() => {
        notification.classList.remove("show");
      }, 2000);
    }
  };

  // Prevent right-click and certain keyboard shortcuts
  useEffect(() => {
    const handleContextMenu = (e) => {
      e.preventDefault();
      showNotification();
    };

    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && (e.key === "s" || e.key === "p")) {
        e.preventDefault();
        showNotification();
      }
    };

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <div className="pdf-viewer-container">
      <div className="viewer-container">
        {loading && (
          <div className="loading pdf_loader">
            Loading PDF document...
            <Loader />
          </div>
        )}
        {error && <div className="error">{error}</div>}
        {!loading && !error && (
          <>
            <div className="watermark">Preview Only</div>
            <div id="pdf-container">
              <div className="canvas-container">
                <canvas ref={canvasRef}></canvas>
              </div>
            </div>
          </>
        )}
      </div>

      {!loading && !error && (
        <div className="controls">
          <button
            id="prev-page"
            className="btn"
            onClick={goToPrevPage}
            disabled={currentPage <= 1}
          >
            Previous
          </button>
          <span className="page-info">
            Page <span id="current-page">{currentPage}</span> of{" "}
            <span id="total-pages">{pageCount || "--"}</span>
          </span>
          <button
            id="next-page"
            className="btn"
            onClick={goToNextPage}
            disabled={currentPage >= pageCount}
          >
            Next
          </button>
          <div className="zoom-controls">
            <button id="zoom-out" className="zoom-btn" onClick={zoomOut}>
              -
            </button>
            <button id="zoom-in" className="zoom-btn" onClick={zoomIn}>
              +
            </button>
          </div>
        </div>
      )}

      {/* <div className="notification" id="pdf-notification">
        Download and print options are disabled
      </div> */}
    </div>
  );
};

export default PreviousPapers;
